import React from "react";
import OrderOverview from "./components/OrderOverview";
import FeaturedOrderStage from "./components/FeaturedOrderStage";
import OrderStatusOnboarding from "./components/OrderStatusOnboarding";
import OrderStatusTimeline from "./components/OrderStatusTimeline";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import OrderDashboardRecentActivity from "../OrderDashboardPage/components/OrderDashboardRecentActivity";
import OrderDashboardJobPosting from "../OrderDashboardPage/components/OrderDashboardJobPosting";
import OrderDashboardShortlist from "../OrderDashboardPage/components/OrderDashboardShortlist";
import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";

function OrderStatusPage() {
  return (
    <div className="bg-gray-100 py-2">
      <OrderMainNav />
      <section className="container mx-auto my-6 flex">
        <section id="left" className="w-1/2 pr-2">
          <OrderOverview />
          <FeaturedOrderStage />
          <OrderStatusTimeline />
        </section>
        <section id="right" className="w-1/2 pl-2">
          <OrderStatusOnboarding />
          <OrderDashboardRecentActivity />
          <OrderDashboardJobPosting />
          <OrderDashboardShortlist />
        </section>
      </section>
    </div>
  );
}

export default OrderLayerBlueprint(OrderStatusPage);
